import React from 'react';
import { Box, Skeleton } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { COLORS } from '../../utils/colors';
import { useTranslation } from 'react-i18next';

export function BarChart({
  chartCategory,
  chartSerieUp,
  chartSerieNoMon,
  chartSerieDown,
  title,
  isLoading,
}) {
  const { t } = useTranslation()
  const chartRef = React.useRef(null);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      if (chartRef.current) {
        chartRef.current.chart.reflow();
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, []);

  React.useEffect(() => {
    if (!isLoading) {
      sessionStorage.setItem(
        'chartAvailabilityNode',
        JSON.stringify(chartOptions)
      );
    }
  }, [isLoading]);

  if (isLoading) {
    return (
      <Box width="100%">
        <Skeleton
          height="100%"
          variant="rectangular"
          style={{
            backgroundColor: '#adadad',
          }}
        />
      </Box>
    );
  }

  const chartOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: title,
    },
    tooltip: {
      enabled: true,
      pointFormat: '<b>{point.y:.2f} (%)</b>',
    },
    xAxis: {
      categories: chartCategory,
      title: {
        text: '' + t('bar-chart.xAxis.title') + '',
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      max: 100,
      min: 0,
      title: {
        text: t('bar-chart.yAxis.label'),
      },
      labels: {
        formatter: function () {
          return this.value + '%';
        },
      },
    },
    series: [
      {
        name: t('bar-chart.series.uptime'),
        color: COLORS.UPTIME,
        data: chartSerieUp,
      },
      {
        name: t('bar-chart.series.downtime'),
        color: COLORS.DOWNTIME,
        data: chartSerieDown,
      },
      {
        name: t('bar-chart.series.no-monitoring'),
        color: COLORS.NO_MONITOREO,
        data: chartSerieNoMon,
      },
    ],
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            if (this.y) {
              return this.y;
            }
            return '';
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <Box ref={containerRef}>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        ref={chartRef}
        containerProps={{style: {height: '100%'}}}
      />
    </Box>
  );
}
